import React, { useState } from "react";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EndcustomerFormGeneral from "Components/Endcustomer/EndcustomerFormGeneral";
import EndcustomerFormSystem from "Components/Endcustomer/EndcustomerFormSystem";
import EndcustomerFormStandardTerms from "./EndcustomerFormStandardTerms";
import Uc from "Components/Client/Tabs/Uc";
import EndcustomerFormContact from "./EndcustomerFormContact";
import { useAuth } from "Hooks/useAuth";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "255px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}
//FORM_MODES = LOCKED/CREATE/CLIENT_CREATE
export default function EndcustomerForm({
  formData,
  FORM_MODE,
  handleInputChange,
  agreementOptions,
  clients,
  boolOptions,
}) {
  const { isAdmin } = useAuth();
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabSwitch}
        sx={{ marginBottom: "2rem" }}
      >
        <Tab label="Allmänt" />
        <Tab label="Kontakt" />
        {isAdmin ? <Tab label="Villkor" key="villkor" /> : null}
        {isAdmin ? <Tab label="System" key="system" /> : null}
        {formData.UC && <Tab label="UC" />}
      </Tabs>
      {isAdmin ? (
        <>
          <TabPanel value={tabIndex} index={0}>
            <EndcustomerFormGeneral
              FORM_MODE={FORM_MODE}
              endcustomer={formData}
              handleInputChange={handleInputChange}
              clients={clients}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <EndcustomerFormContact
              FORM_MODE={FORM_MODE}
              endcustomer={formData}
              handleInputChange={handleInputChange}
              clients={clients}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>
            <EndcustomerFormStandardTerms
              FORM_MODE={FORM_MODE}
              endcustomer={formData}
              agreementOptions={agreementOptions}
              handleInputChange={handleInputChange}
              boolOptions={boolOptions}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
            <EndcustomerFormSystem
              FORM_MODE={FORM_MODE}
              endcustomer={formData}
              handleInputChange={handleInputChange}
              clients={clients}
            />
          </TabPanel>
          {formData.Id && (
            <TabPanel value={tabIndex} index={4}>
              <Uc
                UC={formData}
                handleInputChange={handleInputChange}
                FORM_MODE={FORM_MODE}
              />
            </TabPanel>
          )}
        </>
      ) : (
        <>
          <TabPanel value={tabIndex} index={0}>
            <EndcustomerFormGeneral
              FORM_MODE={FORM_MODE}
              endcustomer={formData}
              handleInputChange={handleInputChange}
              clients={clients}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <EndcustomerFormContact
              FORM_MODE={FORM_MODE}
              endcustomer={formData}
              handleInputChange={handleInputChange}
              clients={clients}
            />
          </TabPanel>
          {formData.Id && (
            <TabPanel value={tabIndex} index={2}>
              <Uc
                UC={formData}
                handleInputChange={handleInputChange}
                FORM_MODE={FORM_MODE}
              />
            </TabPanel>
          )}
        </>
      )}
    </>
  );
}

/*
    ExternalCustomerNr: endcustomer.ExternalCustomerNr,
    ID: endcustomer.ID,
*/
